import React from 'react';
import EntityFiles from '../../components/EntityFiles';

// Car Files tab — now backed by the shared Document Library. Shows every file
// linked to this car (including legacy files keyed by stock) and lets the user
// add more, pre-linked to the car.
export default function Files({ car, readOnly = false }) {
  const carLabel = `${car.stock || ''}${[car.year, car.make, car.model].filter(Boolean).length
    ? ` — ${[car.year, car.make, car.model].filter(Boolean).join(' ')}`
    : ''}`.trim();

  const contactOf = (c, contactLabel) => c && c.email
    ? { label: contactLabel, email: c.email, name: c.display_name || [c.first_name, c.last_name].filter(Boolean).join(' ').trim() }
    : null;
  const signContacts = [
    contactOf(car.buyer, 'Buyer'),
    contactOf(car.cobuyer, 'Co-buyer'),
    contactOf(car.consignor, 'Consignor'),
  ].filter(Boolean);

  return (
    <EntityFiles
      type="car"
      id={car.stock}
      legacyStock={car.stock}
      label={carLabel || car.stock}
      readOnly={readOnly}
      signContacts={signContacts}
    />
  );
}
